module.exports = __webpack_public_path__ + "static/SFUIDisplay-Bold-ad7991367ae9b7bd7d207bd09586a533.woff";